import { SnackbarProps } from '@mui/material';
import { atom } from 'recoil';

export const toastAtom = atom<Partial<SnackbarProps>>({
  key: 'toastAtom',
  default: {
    open: false,
    autoHideDuration: 6000,
    onClose: () => {},
    message: 'Note archived',
  },
});
